import { useEffect, type ReactNode } from 'react';

// Lightweight modal: click-backdrop or Esc to dismiss. Used by every
// add/edit form in the app.
export function Modal({
  title,
  onClose,
  children,
  footer,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal>
        <div className="row between" style={{ marginBottom: '0.9rem' }}>
          <h2 style={{ margin: 0 }}>{title}</h2>
          <button className="btn btn-ghost btn-sm" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        {children}
        {footer && (
          <div className="row wrap" style={{ justifyContent: 'flex-end', marginTop: '1.1rem' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
